import config from 'config';
import moment from 'moment-timezone';

const LOAD = 'greyhound-racing/meetings/LOAD';
const LOAD_SUCCESS = 'greyhound-racing/meetings/LOAD_SUCCESS';
const LOAD_FAIL = 'greyhound-racing/meetings/LOAD_FAIL';

const initialState = {
  byDate: {}
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        byDate: {
          ...state.byDate,
          [action.date]: {
            ...state.byDate[action.date],
            loading: true
          }
        }
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        byDate: {
          ...state.byDate,
          [action.date]: {
            meetings: action.result,
            loading: false,
            loaded: true
          }
        }
      };
    case LOAD_FAIL:
      return {
        ...state,
        byDate: {
          ...state.byDate,
          [action.date]: {
            ...state.byDate[action.date],
            loading: false,
            loaded: false,
            error: action.error
          }
        }
      };
    default:
      return state;
  }
}

export function isLoading(globalState, date) {
  return globalState.greyhoundRacing.meetings
      && globalState.greyhoundRacing.meetings.byDate
      && globalState.greyhoundRacing.meetings.byDate[date]
      && globalState.greyhoundRacing.meetings.byDate[date].loading;
}

// TODO: Swap over to this function if greyhound API swaps to something more sensible
/* export function load(date) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: (client) => client.get(`${config.api.greyhoundRacing.loadMeetings}/${date}`),
    date: date
  };
} */

export function load(date) {
  // We need to presume that the provided timezone is UTC. That way it won't be changed when valueOf converts to UTC.
  let startDate = moment.tz(date, "UTC").startOf('day');

  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: (client) => client.get(`${config.api.greyhoundRacing.loadMeetings}`,
      {
        params : {
          from: startDate.valueOf(),
          to: moment(startDate).add(1, 'day').valueOf()
        }
      }
    ),
    date: date
  };
}

export function get(state) {
  return state.greyhoundRacing.meetings.byDate;
}



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/reducers/meetings.js